import { createAction } from "typesafe-actions";

import { ICreate, ISetData } from "./types";

export const SET_DATA = "prometheus/SET_DATA";
export const CREATE = "prometheus/CREATE";

export const setData = createAction(SET_DATA)<ISetData>();
export const create = createAction(CREATE)<ICreate>();
